import { getHealthScoreQuestionnaire } from "@/services/core-api-adapter";
import { useQuery } from "@tanstack/react-query";
import { QuestionnaireAnswers, QuestionnaireType } from "../types";

export const healthScoreQuestionnaireQueryKey = (type: QuestionnaireType) =>
  ["healthScoreQuestionnaire", type] as const;

export default function useGetHealthScoreQuestionnaire(
  type: QuestionnaireType
) {
  const { data, isPending, isLoading, isError, error, refetch } = useQuery({
    queryKey: healthScoreQuestionnaireQueryKey(type),
    queryFn: async ({ signal }) => {
      const result = await getHealthScoreQuestionnaire(type, { signal });
      return result as QuestionnaireAnswers | null;
    },
  });

  return {
    questionnaireData: data ?? undefined,
    isQuestionnaireLoading: isPending || isLoading,
    questionnaireFetchError: error ?? isError,
    refetchQuestionnaire: refetch,
  };
}
